import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { ON_ROUTE_CHANGE } from 'actions/header';
import { Route, Switch, withRouter } from 'react-router-dom';
import { appInsights } from 'lib/appInsight';
import { useHistory } from 'react-router';

// Import routes
import ConversationPage from 'containers/Conversation/Display/ConversationPage';
import ConversationsPage from 'containers/Conversation/Display/ConversationsPage';
import AllForms from 'containers/FormTemplate/Page/AllForms';
import SingleForm from 'containers/FormTemplate/Page/SingleForm';
import CallbackPage from 'components/CallbackPage/CallbackPage';
import Login from 'components/Login/Login';
import Logout from 'components/Logout/Logout';
import LoadingPage from 'components/LoadingPage/LoadingPage';
import Profile from 'components/Profile/Profile';
import SchoolSwitch from 'components/SchoolSwitch/SchoolSwitch';
import AllPlans from 'containers/AllPages/AllPlans';
import AllPosts from 'containers/AllPages/AllPosts';
import AllTasks from 'containers/AllPages/AllTasks';
import App from 'containers/App';
import IndexWrapper from 'containers/IndexWrapper';
import Meeting from 'containers/Meetings/Display/Meeting';
import MeetingInstance from 'containers/Meetings/Display/MeetingInstance';
import MyMeetings from 'containers/Meetings/Display/MyMeetings';
import NotFound from 'containers/NotFound';
import StudentProgress from 'containers/Progress/StudentProgress';
import SectionWrapper from 'containers/Section/SectionWrapper';
import Absence from 'containers/Overview/Sections/Absence';
import Schedule from 'containers/Schedule/Schedule';
import AssignmentsWrapper from 'containers/SinglePages/Assignments/AssignmentsWrapper';
import SingleDocument from 'containers/SinglePages/SingleDocument';
import singlePlan from 'containers/SinglePages/SinglePlan';
import SinglePost from 'containers/SinglePages/SinglePost';
import StudyPlan from 'containers/StudyPlan/StudyPlan';
import Notifications from 'containers/Notifications';
import Groups from 'containers/Groups';
import NotificationReceiver from 'containers/Notifications/NotificationReceiver';
import RedirectOld from 'components/Redirect/Old';
var Routes = function Routes(props) {
  var history = useHistory();
  var _useState = useState(location.pathname),
    _useState2 = _slicedToArray(_useState, 2),
    currentPath = _useState2[0],
    setPreviousRouteRoute = _useState2[1];
  useEffect(function () {
    var listener = document.addEventListener('login_required', function () {
      history.push('/login');
    });
    history.listen(function (location) {
      if (location == null) {
        return false;
      }
      var forbiddenRoutes = ["language", "switch", "conversations/new", "Auth"];
      if (location.pathname == currentPath) {
        return false;
      }
      if (location.hostname != 'localhost') {
        appInsights.trackPageView({
          name: location.pathname,
          isLoggedIn: appInsights.context.user.authenticatedId != null
        });
      }
      var route = forbiddenRoutes.find(function (t) {
        return location.pathname.indexOf(t) > -1;
      });
      if (route != null) {
        return false;
      }
      setPreviousRouteRoute(location.pathname);
      props.store.dispatch({
        type: ON_ROUTE_CHANGE
      });
      window.scrollTo(0, 0);
      if (location.pathname != '/login' && location.pathname != '/logout') {
        var event = new Event('route_change');
        document.dispatchEvent(event);
      }
    });
    return function () {
      document.removeEventListener('login', listener);
    };
  }, []);
  return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "/loading",
    name: "Loading",
    component: LoadingPage
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/login",
    component: Login
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/logout",
    exact: true,
    component: Logout
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/loginRedirect",
    component: CallbackPage
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/",
    render: function render() {
      return /*#__PURE__*/React.createElement(App, null, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
        path: "/",
        exact: true,
        component: IndexWrapper
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/posts",
        exact: true,
        name: "Posts",
        component: AllPosts
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/posts/:newsId",
        name: "SinglePost",
        component: SinglePost
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/documents/:documentId",
        name: "document",
        component: SingleDocument
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/schedule",
        name: "Schedule",
        component: Schedule
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/notifications",
        name: "Notifications",
        component: Notifications
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/notificationReceiver",
        name: "NotificationReceiver",
        component: NotificationReceiver
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/plans",
        exact: true,
        name: "Plans",
        component: AllPlans
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/plan/:planId",
        name: "plan",
        component: singlePlan
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/groups",
        exact: true,
        name: "Groups",
        component: Groups
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/groups/:groupId",
        name: "Group",
        component: SectionWrapper
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/assignments",
        exact: true,
        name: "Assignments",
        component: AllTasks
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/assignment/:assignmentId",
        name: "Assignment",
        component: AssignmentsWrapper
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/conversations",
        exact: true,
        name: "Conversations",
        component: ConversationsPage
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/conversations/:id",
        name: "Conversation",
        component: ConversationPage
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/studyplan",
        name: "StudyPlan",
        component: StudyPlan
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/progress",
        name: "StudentProgress",
        component: StudentProgress
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/profile",
        name: "profile",
        component: Profile
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/switchschool",
        name: "switchschool",
        component: SchoolSwitch
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/forms",
        exact: true,
        name: "AllForms",
        component: AllForms
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/form/:id",
        name: "SingleForm",
        component: SingleForm
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/absence",
        name: "Absence",
        component: Absence
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/meetings",
        exact: true,
        name: "Meetings",
        component: MyMeetings
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/meetings/:id",
        exact: true,
        name: "Meeting",
        component: Meeting
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/meetings/:id/instance/:instanceId",
        exact: true,
        name: "Meeting",
        component: MeetingInstance
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/404",
        name: "notfound",
        component: NotFound,
        status: 404
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/student/:studentId",
        name: "Redirect",
        component: RedirectOld
      }), /*#__PURE__*/React.createElement(Route, {
        path: "/student/:studentId/*",
        name: "Redirect",
        component: RedirectOld
      })));
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    component: NotFound,
    status: 404
  }));
};
export default withRouter(Routes);